'use strict';
import angular from 'angular';
import './scripts/inOutStatus.ctrls';
import './scripts/inOutStatus.directives';
import './scripts/inOutStatus.services';

import userAvailabilityHtmlUrl from './views/userAvailability.html';

angular.module('inOutStatus', [
    'inOutStatus.ctrls',
    'inOutStatus.directive',
    'inOutStatus.services'
])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('userAvailability', {
                parent: 'layout',
                url: '/userAvailability',
                templateUrl: userAvailabilityHtmlUrl,
                controller: 'UserAvailabilityController'
            })
    }])